const dev = {
  API_ENDPOINT_URL: "https://api.helixdiamond.com",
  // API_ENDPOINT_URL: "https://h5gtm208-3018.inc1.devtunnels.ms",

};

const prod = {
  API_ENDPOINT_URL: "https://api.helixdiamond.com",
  // API_ENDPOINT_URL: "https://h5gtm208-3018.inc1.devtunnels.ms",

};

const test = {
  API_ENDPOINT_URL: "https://api.helixdiamond.com",
  // API_ENDPOINT_URL: "https://h5gtm208-3018.inc1.devtunnels.ms",
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    case "test":
      return test;
    default:
      break;
  }
};

export const env = getEnv();
